import { Controller } from 'stimulus';

const MAX_USERS = 3;

class UserPreferenceController extends Controller {
  connect() {
    this.outputSelectedUsers();
  }

  onUserSelect() {
    this.outputSelectedUsers();
  }

  onUserRemove({ currentTarget }) {
    const { id } = currentTarget.dataset;
    const activeUserById = this.usersTarget.querySelector(`input[data-id="${id}"]`);

    if (!activeUserById) return;

    activeUserById.checked = false;

    this.outputSelectedUsers();
  }

  disableUsers() {
    this.getUnselectedUsers().forEach((user) => {
      user.disabled = this.getSelectedUsers().length === MAX_USERS;
    });
  }

  outputSelectedUsers() {
    this.disableUsers();

    this.selectedUsersTarget.innerHTML = '';

    this.getSelectedUsers().forEach((user) => {
      const item = UserPreferenceController.createSelectedUserItem(
        parseInt(user.dataset.id, 10),
        user.dataset.name,
      );

      this.selectedUsersTarget.insertAdjacentHTML('beforeend', item);
    });
  }

  getSelectedUsers() {
    return this.userTargets.filter((user) => user.checked);
  }

  getUnselectedUsers() {
    return this.userTargets.filter((user) => !user.checked);
  }

  static createSelectedUserItem(id, name) {
    return `
      <button
        type="button"
        class="user-selection__item btn"
        data-id="${id}"
        data-name="${name}"
        data-action="click->user-preference#onUserRemove"
      >
        ${name} ${UserPreferenceController.getIcon('times')}
      </button>
    `;
  }

  static getIcon(name) {
    return `<svg class="icon icon-${name}" aria-hidden="true"><use xlink:href="#icon-${name}"></use></svg>`;
  }
}

UserPreferenceController.targets = [
  'user',
  'users',
  'selectedUsers',
];

export default UserPreferenceController;
